module.exports = __webpack_public_path__ + "img/category-favorite.d75c352e.png";